import { Col } from 'antd'
import styled from 'styled-components'

const StyledIngredientKeywordsColumnHeader = styled(Col)`
  background-color: white;
  border: 1px solid #fafafa;
  padding: 8px 10px;
`

export default StyledIngredientKeywordsColumnHeader
